import { render, staticRenderFns } from "./CardPackagingIcon.vue?vue&type=template&id=2a6c253a"
import script from "./CardPackagingIcon.vue?vue&type=script&lang=js"
export * from "./CardPackagingIcon.vue?vue&type=script&lang=js"
import style0 from "./CardPackagingIcon.vue?vue&type=style&index=0&id=2a6c253a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports